export const asNonI18n = (value: string): string => value;
